import React, { Component } from "react";
import DatePicker from "react-date-picker";
import moment from "moment";
import { ListGroup, ListGroupItem, Table } from "reactstrap";
import { connect } from "react-redux";
import Ink from "react-ink";

import api from "../../config/api";
import authActions from "../../redux/auth/action";
import referralActions from "../../redux/referral/action";
import editIcon from "../../assets/icons/edit.png";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class MyReferrals extends Component {
  state = {
    showCalender: true,
    isLoading: false,
  };

  componentWillReceiveProps = (nextProps) => {
    const { from, to } = this.props;
    const { from: nextFrom, to: nextTo } = nextProps;

    if (!moment(from).isSame(nextFrom)) {
      this.fetchReferrals(nextFrom, nextTo);
    } else if (!moment(to).isSame(nextTo)) {
      this.fetchReferrals(nextFrom, nextTo);
    }
  };

  handlePickerChange = (key, value) => {
    let { setMyReferralsInput, to, setAlertMessage } = this.props;

    if (key === "from" && moment(to).isBefore(value)) {
      this.setState({ showCalender: false }, () => {
        setAlertMessage({
          type: "error",
          message: "From date can not be higher than to",
        });

        this.setState({ showCalender: true });
      });
      return;
    }
    const reduxPayload = {
      [key]: value,
    };

    setMyReferralsInput(reduxPayload);
  };

  changeTimePeriod = (period) => {
    const { setMyReferralsInput } = this.props;
    let from, to;

    if (period === "this_year") {
      from = moment().startOf("year");

      to = moment();
    } else if (period === "last_year") {
      from = moment().subtract(1, "year").startOf("year");

      to = moment().subtract(1, "year").endOf("year");
    } else if (period === "quarter") {
      from = moment().subtract(1, "quarter").startOf("quarter");

      to = moment();
    }

    setMyReferralsInput({ from, to });
  };

  fetchReferrals = async (from, to) => {
    const { user, setMyReferralsInput, setAlertMessage } = this.props;

    try {
      this.setState({ isLoading: true });

      const payload = {
        sDate: moment(from).format("MMMM-DD-YYYY"),
        eDate: moment(to).format("MMMM-DD-YYYY"),
      };

      const response = await api.getMyReferrals(payload, user.token);
      setMyReferralsInput({ result: response.data.result });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? () => this.fetchReferrals(from, to)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const { from, to, result = [] } = this.props;
    const { isLoading } = this.state;

    return (
      <div>
        <PageHead title="MY REFERRALS" containerStyles={{ width: "100%" }} />
        <ListGroup className="mt-2">
          <ListGroupItem className="reward-system-picker-container">
            <p className="pr-1">Time Period</p>
            <div className="reward-system-picker">
              {this.state.showCalender && (
                <DatePicker
                  calendarIcon={<CalenderIcon />}
                  calendarClassName="reward-system-calender-main-container"
                  className="reward-system-calender-field mr-1"
                  value={new Date(from)}
                  format="M/d/yyyy"
                  onChange={(value) => this.handlePickerChange("from", value)}
                />
              )}
              {this.state.showCalender && (
                <DatePicker
                  calendarIcon={<CalenderIcon />}
                  calendarClassName="reward-system-calender-main-container"
                  className="reward-system-calender-field mr-1"
                  value={new Date(to)}
                  minDate={from && new Date(moment(from))}
                  format="M/d/yyyy"
                  onChange={(value) => this.handlePickerChange("to", value)}
                />
              )}
            </div>
            <div className="transaction-details-calender-btns-container">
              <button
                className="transaction-details-calender-btn btn"
                onClick={this.changeTimePeriod.bind(this, "this_year")}
              >
                This Year
                <Ink />
              </button>
              <button
                className="transaction-details-calender-btn mx-1 btn"
                onClick={this.changeTimePeriod.bind(this, "last_year")}
              >
                Last Year
                <Ink />
              </button>
              <button
                className="transaction-details-calender-btn btn"
                onClick={this.changeTimePeriod.bind(this, "quarter")}
              >
                Last Quarter
                <Ink />
              </button>
            </div>
          </ListGroupItem>
        </ListGroup>
        <Table className="mt-2 history-table-container" bordered responsive>
          <thead>
            <th>First Name</th>
            <th>Sur Name</th>
            <th>Other Names</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>NIN</th>
            <th>Date Of Birth</th>
            <th>State Of Origin</th>
            <th>LGA Of Origin</th>
          </thead>
          <tbody>
            {result.map((item) => (
              <tr>
                <td>{item.firstName}</td>
                <td>{item.surname}</td>
                <td>{item.otherNames}</td>
                <td>{item.phone}</td>
                <td>{item.email}</td>
                <td>{item.nin}</td>
                <td>{item.dateofbirth}</td>
                <td>{item.stateOfOrigin}</td>
                <td>{item.LGA}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        {isLoading && <CustomLoader />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.referral.myReferrals,
  user: state.auth.user,
});

const mapDispatchToProps = {
  setMyReferralsInput: referralActions.setMyReferralsInput,
  setAlertMessage: authActions.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyReferrals);

function CalenderIcon() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img alt="edit-icon" src={editIcon} width="20px" />
    </div>
  );
}
